import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4e2be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "回答時間", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.95}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.9}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.85}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.8}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.75}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.7}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.65}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.6}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.55}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage1", {'ov': _ctx.per <= 0.5}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage2", {'ov': _ctx.per <= 0.45}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage2", {'ov': _ctx.per <= 0.4}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage2", {'ov': _ctx.per <= 0.35}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage2", {'ov': _ctx.per <= 0.3}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage2", {'ov': _ctx.per <= 0.25}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage3", {'ov': _ctx.per <= 0.2}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage3", {'ov': _ctx.per <= 0.15}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage3", {'ov': _ctx.per <= 0.1}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage3", {'ov': _ctx.per <= 0.05}])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["gage gage4", {'ov': _ctx.per <= 0.01}])
      }, null, 2)
    ])
  ]))
}